module.exports = __webpack_public_path__ + "imgesssyaa/svg/More.99cf8ebe.svg";